<template>
  <div
    class="participant-type light--text"
    :class="roleDescription.color"
    @click.stop
  >
    {{ roleDescription.label }}
  </div>
</template>

<script>
const participantRoles = {
  host: {
    label: 'Host',
    color: 'primary',
  },
  guest: {
    label: 'Guest',
    color: 'appMain',
  },
};

export default {
  name: 'ParticipantRoleBadge',
  props: {
    isHost: Boolean,
  },
  computed: {
    roleDescription() {
      return participantRoles[this.isHost ? 'host' : 'guest'];
    },
  },
};
</script>
